<script>
export let currentRoute;


import { onMount } from 'svelte';


import Loading from 'components/elements/Loading.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';


import Form from 'components/forms/views/form/test/Form.svelte';



import SvelteSeo from 'svelte-seo';



const forms_api_url = app_.env.FORMS_API_URL;



</script>


<style>

</style>



<section class="hero bg-grey">

	<div class="hero-body">

		<div class="container">

			<p class="hero-subtitle has-text-centered">
				Jersey Sponsor Form Test
			</p>

		</div>

	</div>

</section>


<section class="section skinny-section">

	<div class="container" style="max-width: 800px !important;">

		<MsgCard msg_show={true} msg_text={'Laboris cupidatat incididunt cillum reprehenderit cillum veniam sunt aliqua sint.'} msg_type={'error'} msg_forever={true} />

		<div class="card form-card">

			<div class="card-content">

				<Form />

			</div>

		</div>

	</div>

</section>




